import { Component, OnDestroy, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { interval, Subscription, take } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { SecondsToMinutesPipe } from '@app/pipes/seconds-to-minutes.pipe';

@Component({
    selector: 'app-lockout-modelations-dialog',
    templateUrl: './lockout-dialog.component.html',
    imports: [MatDialogModule, MatButtonModule, SecondsToMinutesPipe],
})
export class LockoutDialogComponent implements OnDestroy {
    dialogRef = inject<MatDialogRef<LockoutDialogComponent>>(MatDialogRef);

    seconds = -1;

    private subscription: Subscription | null = null;

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    startCountdown() {
        this.subscription = interval(1000)
            .pipe(take(this.seconds))
            .subscribe({
                next: () => {
                    this.seconds--;
                },
            });
    }

    closeDialog() {
        this.dialogRef.close(false);
    }
}
